import { render, staticRenderFns } from "./DashboardPentagonChart.vue?vue&type=template&id=1e479ffd&scoped=true&"
import script from "./DashboardPentagonChart.vue?vue&type=script&lang=js&"
export * from "./DashboardPentagonChart.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPentagonChart.vue?vue&type=style&index=0&id=1e479ffd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e479ffd",
  null
  
)

export default component.exports